export type SendsarErrorPayload = {
  error?: string;
  message?: string;
  statusCode?: number;
};

/** Parse gateway JSON error bodies when present. */
export function parseSendsarErrorBody(body: string): SendsarErrorPayload | null {
  const trimmed = body.trim();
  if (!trimmed.startsWith("{")) return null;
  try {
    return JSON.parse(trimmed) as SendsarErrorPayload;
  } catch {
    return null;
  }
}

export class SendsarError extends Error {
  readonly status: number;
  readonly body: string;
  readonly payload: SendsarErrorPayload | null;

  constructor(message: string, status: number, body: string) {
    const payload = parseSendsarErrorBody(body);
    const detail = payload?.error ?? payload?.message;
    super(detail ? `${message}: ${detail}` : message);
    this.name = "SendsarError";
    this.status = status;
    this.body = body;
    this.payload = payload;
  }
}

export async function assertOk(response: Response, action: string): Promise<void> {
  if (!response.ok) {
    const body = await response.text();
    throw new SendsarError(`Sendsar ${action} failed: ${response.status}`, response.status, body);
  }
}
